import React, { useRef, useEffect } from "react";

const Map = ({ location = "both", height = "400px" }) => {
  const mapRef = useRef(null);

  const locations = {
    herzliya: {
      position: { lat: 32.16721951284615, lng: 34.84444527431377 },
      title: "מרפאת הרצליה",
      address: "רחוב סוקולוב 27, הרצליה",
      zoom: 16,
    },
    beersheba: {
      position: { lat: 31.24529224862607, lng: 34.81328667346476 },
      title: "מרפאת באר שבע",
      address: "אליהו נאוי 24 (מתחם וורקיז קומת כניסה), באר שבע",
      zoom: 16,
    },
    both: {
      center: { lat: 32.168041356830706, lng: 34.84254438780725 },
      zoom: 8,
    },
  };

  useEffect(() => {
    const loadGoogleMaps = () => {
      if (window.google && window.google.maps) {
        initializeMap();
      } else {
        const script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyCAAwPdzWL4kCTCcFb1Wsf8_BCIf9TwCGQ&language=he&region=IL&libraries=&callback=initializeMap";
        script.async = true;
        script.defer = true;
        window.initializeMap = initializeMap;
        document.body.appendChild(script);
      }
    };

    const initializeMap = () => {
      if (!mapRef.current) return;

      let mapConfig;
      let markers = [];

      if (location === "both") {
        // Show both locations
        mapConfig = {
          center: locations.both.center,
          zoom: locations.both.zoom,
        };
        markers = [
          {
            position: locations.herzliya.position,
            title: locations.herzliya.title,
            content: `<div style="direction: rtl; text-align: center; padding: 10px;">
              <h3 style="margin: 0 0 5px 0; color: #01727a;">${locations.herzliya.title}</h3>
              <p style="margin: 0; font-size: 14px;">${locations.herzliya.address}</p>
            </div>`,
          },
          {
            position: locations.beersheba.position,
            title: locations.beersheba.title,
            content: `<div style="direction: rtl; text-align: center; padding: 10px;">
              <h3 style="margin: 0 0 5px 0; color: #01727a;">${locations.beersheba.title}</h3>
              <p style="margin: 0; font-size: 14px;">${locations.beersheba.address}</p>
            </div>`,
          },
        ];
      } else {
        // Show single location
        const selectedLocation = locations[location];
        mapConfig = {
          center: selectedLocation.position,
          zoom: selectedLocation.zoom,
        };
        markers = [
          {
            position: selectedLocation.position,
            title: selectedLocation.title,
            content: `<div style="direction: rtl; text-align: center; padding: 15px;">
              <h3 style="margin: 0 0 8px 0; color: #01727a;">${
                selectedLocation.title
              }</h3>
              <p style="margin: 0 0 10px 0; font-size: 14px;">${
                selectedLocation.address
              }</p>
              <div style="display: flex; gap: 10px; justify-content: center; margin-top: 10px;">
                                 <a href="https://waze.com/ul?q=${encodeURIComponent(
                                   selectedLocation.address
                                 )}&navigate=yes" 
                    target="_blank" 
                    style="background: #3490dc; color: white; padding: 5px 10px; text-decoration: none; border-radius: 5px; font-size: 12px;">
                    ווייז
                  </a>
                 <a href="https://maps.google.com/?q=${encodeURIComponent(
                   selectedLocation.address
                 )}" 
                    target="_blank"
                    style="background: #4285f4; color: white; padding: 5px 10px; text-decoration: none; border-radius: 5px; font-size: 12px;">
                    גוגל מפות
                  </a>
              </div>
            </div>`,
          },
        ];
      }

      const map = new window.google.maps.Map(mapRef.current, {
        ...mapConfig,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "road",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
        ],
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
        language: "he",
        region: "IL",
      });

      markers.forEach(({ position, title, content }) => {
        const marker = new window.google.maps.Marker({
          position,
          map,
          title,
          animation: window.google.maps.Animation.DROP,
          icon: {
            url:
              "data:image/svg+xml;charset=UTF-8," +
              encodeURIComponent(`
              <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="18" fill="#01727a" stroke="white" stroke-width="2"/>
                <circle cx="20" cy="20" r="8" fill="white"/>
              </svg>
            `),
            scaledSize: new window.google.maps.Size(40, 40),
            anchor: new window.google.maps.Point(20, 20),
          },
        });

        if (location !== "both") {
          marker.addListener("click", () => {
            map.setZoom(18);
          });
        }

        const infoWindow = new window.google.maps.InfoWindow({
          content,
        });

        marker.addListener("click", () => {
          infoWindow.open({ anchor: marker, map, shouldFocus: false });
        });
      });
    };

    loadGoogleMaps();
  }, [location]);

  return (
    <div
      ref={mapRef}
      style={{
        width: "100%",
        height: height,
        borderRadius: "20px",
        overflow: "hidden",
      }}
    />
  );
};

export default Map;
